import { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { uniqBy } from 'lodash'
import * as Fbs from '@edulastic/common/src/Firebase'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { assignmentStatusOptions } from '@edulastic/constants'
import { withNamespaces } from '@edulastic/localization'
import { getUser, getUserOrgId } from '../../../src/selectors/user'
import {
  destroyNotificationMessage,
  notificationMessage,
} from '../../../../common/components/Notification'

const collectionName = 'AsyncAssignmentsStatus'
const notificationDuration_90sec = 90

const NotificationListener = ({ user, t }) => {
  const [notificationIds, setNotificationIds] = useState([])

  const userNotifications = Fbs.useFirestoreRealtimeDocuments(
    (db) => db.collection(collectionName).where('userId', '==', `${user?._id}`),
    [user?._id]
  )

  const deleteNotificationDocument = (docId) => {
    Fbs.db
      .collection(collectionName)
      .doc(docId)
      .delete()
      .catch((err) => console.error(err))
  }

  const showUserNotifications = (docs) => {
    uniqBy(docs, '__id').forEach((doc) => {
      const { processStatus, tests, playlistModuleTitle, autoAssign } = doc
      const isQAenv = process.env.REACT_APP_QA_ENV
      if (
        processStatus === assignmentStatusOptions.DONE &&
        !notificationIds.includes(doc.__id)
      ) {
        const { title: testTitle, totalClassesAssigned } =
          Object.values(tests)[0] || {}
        setNotificationIds([...notificationIds, doc.__id])
        const autoAssignRuleSuccessMsg = autoAssign
          ? t('asyncAssignRuleSuccess.message')
          : ''
        let message = `<b>${testTitle}</b> is assigned successfully to <b>${totalClassesAssigned}</b> class(es)${autoAssignRuleSuccessMsg}`
        if (playlistModuleTitle && Object.values(tests)?.length > 1) {
          message = `<b>${playlistModuleTitle}</b> is assigned successfully to the class(es)${autoAssignRuleSuccessMsg}`
        }
        const notificationMsg = {
          title: 'Assign Assignment',
          message,
          notificationPosition: 'bottomRight',
          notificationKey: doc.__id,
          onCloseNotification: () => {
            deleteNotificationDocument(doc.__id)
          },
        }
        if (isQAenv) {
          notificationMsg.duration = notificationDuration_90sec
        }
        notificationMessage(notificationMsg)
      }
    })
  }

  useEffect(() => {
    if (user) {
      showUserNotifications(userNotifications)
    }
  }, [userNotifications])

  useEffect(
    () => () => {
      destroyNotificationMessage()
    },
    []
  )

  return null
}

export default compose(
  withNamespaces('notifications'),
  withRouter,
  connect(
    (state) => ({
      user: getUser(state),
      orgId: getUserOrgId(state),
    }),
    {}
  )
)(NotificationListener)
